import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import documentUploadIcon from "../../assets/images/pms/document_upload.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import swal from "sweetalert";
import { FaEllipsisV, FaUser } from "react-icons/fa";
import editIcon from "../../assets/images/pms/Edit_icon.svg";
import Select from "react-select";
import deleteIcon from "../../assets/images/pms/Delete_icon.svg";
import { Pie } from "react-chartjs-2";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import {
  AdddepartmentHrmodal,
  DocumentModalAdmin,
  EditEmployeeModalAdmin,
} from "../Modal";
import { ExportToExcel, excelMapping, now } from "../../utils/utilFuctions";
import "../../index.css";
import SalaryReportIcon from "../../assets/images/pms/salary_report.svg";

import {
  FiHome,
  FiChevronRight,
  FiDownload,
  FiUsers,
  FiMonitor,
  FiTrendingUp,
  FiHeadphones,
} from "react-icons/fi";
import "./EmployeeManagement.css";

const arr = [{ label: "Name", value: "Name" }];
export const columns = [
  {
    dataField: "firstname",
    text: "First Name",
  },
  {
    dataField: "lastname",
    text: "Last Name",
  },

  {
    dataField: "mobile",
    text: "Mobile",
  },
  {
    dataField: "designation",
    text: "Designation",
  },

  {
    dataField: "department",
    text: "Department ",
  },
  {
    dataField: "emp_type",
    text: "Employee Type ",
  },

  {
    dataField: "address",
    text: "Address ",
  },

  {
    dataField: "email",
    text: "Email ",
  },

  {
    dataField: "dob",
    text: "DOB ",
  },

  {
    dataField: "joiningdate",
    text: "joining Date ",
  },
  {
    dataField: "bankaccno",
    text: "Bank name",
  },
  {
    dataField: "bankifsc",
    text: "IFSC",
  },

  {
    dataField: " bankname",
    text: "Acount",
  },
  {
    dataField: "qualification",
    text: "Qualification",
  },
  {
    dataField: "age",
    text: "Age",
  },

  {
    dataField: "pan",
    text: "PAN",
  },
];
const EmployeeListAdmin = () => {
  const { password, username } = billpunchbasicauth;
  const [popoverStates, setPopoverStates] = useState({});
  const [desable, setdesable] = useState("");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { accessData } = useContext(GlobalContext);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [department, setDepartment] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [docmodal, setdocmodal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    middlename: "",
    lastname: "",
    mobile: "",
    email: "",
    address: "",
    designation: "",
    wphone: "",
    salary: "",
    date: "",
    aadharno: "",
    department: "",
    dob: "",
    panno: "",
    epf_no: "",
    joiningdate: "",
    bankname: "",
    bankifsc: "",
    bankaccno: "",
    emp_type: "",
    workemail: "",
    pan: "",
    qualification: "",
  });
  const [pieData, setPieData] = useState({
    labels: [
      "Total Employee",
      "IT Employee",
      "Sales Employee",
      "Support Employee",
    ],
    datasets: [
      {
        data: [0, 0, 0, 0],
        backgroundColor: ["red", "cornflowerblue", "blue", "green"],
      },
    ],
  });
  // useEffect(() => {
  //   console.log("Access Data:", accessData);
  // }, [accessData]);

  const pieOptions = {
    maintainAspectRatio: false, // 👈 Allows custom sizing
    plugins: {
      datalabels: {
        display: false, // Hides data labels
      },
      legend: {
        display: false, // Hides legend
      },
    },
  };

  const [errors, setErrors] = useState({
    firstname: "",
    middlename: "",
    lastname: "",
    mobile: "",
    email: "",
    address: "",
    designation: "",
    salary: "",
    date: "",
    aadharno: "",
    department: "",
    dob: "",
    panno: "",
    epf_no: "",
    joiningdate: "",
    workemail: "",
    pan: "",
    qualification: "",
  });
  const validateForm = () => {
    // console.log("Validating form...");
    const newErrors = {};
    const spaceRegex = /^\s+/;

    if (formData.firstname.trim() === "") {
      newErrors.firstname = "First Name is required";
    }

    if (!formData.lastname || formData.lastname.trim() === "") {
      newErrors.lastname = "Last Name is required";
    }

    if (!formData.mobile || formData.mobile.trim() === "") {
      newErrors.mobile = "Mobile number is required";
    }

    if (!formData.email || formData.email.trim() === "") {
      newErrors.email = "Email is required";
    }

    if (formData.address.trim() === "") {
      newErrors.address = "Address is required";
    }
    if (spaceRegex.test(formData.workemail)) {
      errors.workemail = "*Work email should not start with a space";
    } else if (formData.workemail.trim() === "") {
      errors.workemail = "*Please enter Work email";
    }

    if (spaceRegex.test(formData.pan)) {
      errors.pan = "*Pan should not start with a space";
    } else if (formData.pan.trim() === "") {
      errors.pan = "*Please enter Pan";
    }

    if (spaceRegex.test(formData.qualification)) {
      errors.qualification = "*Qualification should not start with a space";
    } else if (formData.qualification.trim() === "") {
      errors.qualification = "*Please enter Qualification";
    }

    if (!formData.joiningdate) {
      errors.joiningdate = "*Please select a valid Joining Date";
    }
    if (!formData.dob) {
      errors.dob = "*Please select a valid Date of Birth";
    }
    if (formData.department === "") {
      newErrors.department = "Department is required";
    }

    if (formData.aadharno === "") {
      newErrors.aadharno = "Aadhar Number is required";
    }

    if (formData.epf_no === "") {
      newErrors.epf_no = "EPF Number is required";
    }

    // if (!formData.joiningdate) {
    // newErrors.joiningdate = "Joining Date is required";
    // }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // console.log("Calling API...");
      handleEditSubmit(selectedEmployee.empid);
      // console.log("API call complete");
    }

    return Object.keys(newErrors).length === 0;
  };

  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartmentData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const togglePopover = (empid) => {
    setPopoverStates((prevState) => ({
      ...prevState,
      [empid]: !prevState[empid],
    }));
  };

  const employeedisable = async (empid) => {
    // Show confirmation dialog
    swal({
      title: "Are you sure?",
      text: "Once disabled, you will not be able to recover this employee!",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    })
      .then((confirmed) => {
        if (confirmed) {
          // User confirmed, proceed with API call
          setTransactionLoaderState(true);
          try {
            const base64Credentials = btoa(`${username}:${password}`);

            var raw = JSON.stringify({
              empid: empid,
            });

            var requestOptions = {
              method: "POST",
              headers: {
                Authorization: `Basic ${base64Credentials}`,
                "Content-Type": "application/json",
              },
              body: raw,
              redirect: "follow",
            };

            return fetch(
              `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/DisableEmployee`,
              requestOptions,
            );
          } catch (error) {
            console.log("error", error);
            swal(
              "Error",
              "An error occurred while disabling the employee.",
              "error",
            );
          } finally {
            setTransactionLoaderState(false);
          }
        } else {
          // User cancelled, do nothing
        }
      })
      .then(async (res) => {
        if (res) {
          const data = await res.json();
          if (data.status === "0") {
            setdesable(data.data);
            swal("Success", "Employee disabled successfully.", "success");
            getEmployeeList();
          } else {
            swal("Error", "Failed to disable employee.", "error");
            getEmployeeList();
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
        swal(
          "Error",
          "An error occurred while disabling the employee.",
          "error",
        );
      });
  };
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };
  const openDocumentUploadModal = (id, firstname, lastname) => {
    sessionStorage.setItem("employeeName", `${firstname} ${lastname}`);

    setSelectedEmployeeId(id);
    setdocmodal(true);
  };

  const closeDocumentUploadModal = () => {
    setdocmodal(false);
  };
  const openEditModal = (id, empid) => {
    setSelectedEmployee(id);
    setSelectedEmployeeId(empid);

    setIsModalOpen(true);
  };

  const closeEditModal = () => {
    setIsModalOpen(false);
    setSelectedEmployee(null);
  };

  const deleteEmployee = (empid) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Employee Details!",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        handleDelete(empid);
      }
    });
  };
  const handleDelete = async (empid) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empId: empid,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/deleteEmployee `,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        getEmployeeList();
        swal("Success", data.result, "success");
      } else {
        getEmployeeList();
        swal("Error", data.result, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      swal("Error", "An error occurred while deleting the tower.", "error");
    }
    setTransactionLoaderState(false);
  };

  const getEmployeeList = async () => {
    // console.log(accessData);
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmId: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setData(data.data);

        const departmentCounts = {};
        data.data.forEach((employee) => {
          const department = employee.department;
          if (departmentCounts[department]) {
            departmentCounts[department]++;
          } else {
            departmentCounts[department] = 1;
          }
        });

        const labels = Object.keys(departmentCounts);
        const counts = Object.values(departmentCounts);

        setPieData({
          labels: labels,
          datasets: [
            {
              data: counts,
              backgroundColor: [
                "#9AD0C2",
                "#41C9E2",
                "#FEC7B4",
                "#B0C5A4",
                "#BFEA7C",
                "#FFF67E",
                "#FFAF45",
              ],
            },
          ],
        });
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const formatDateString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const handleEditSubmit = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: selectedEmployeeId,

        firm_id: user.firm_id,
        firstname: formData.firstname,
        middlename: formData.middlename,
        lastname: formData.lastname,
        address: formData.address,
        mobile: formData.mobile,
        email: formData.email,
        designation: formData.designation,
        epf_no: formData.epf_no,
        department: formData.department,
        joiningdate: formatDateString(formData.joiningdate),
        emp_type: formData.emp_type,
        dob: formatDateString(formData.dob),
        bankname: formData.bankName,
        bankifsc: formData.ifscCode,
        bankaccno: formData.accountNumber,
        qualification: formData.qualification,
        pan: formData.pan,
        work_email: formData.workemail,
      });

      // console.log(formData.id, "adiii");
      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/editEmployee `,
        requestOptions,
      );
      const data = await res.json();
      if (data.status == "0") {
        getEmployeeList();
        swal("Success", data.msg, "success");
        closeEditModal();
      } else {
        getEmployeeList();
        closeEditModal();
        swal("Error", data.msg, "warning");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  useEffect(() => {
    getEmployeeList();
    getDepartmentList();
    //getAccessData();
  }, []);
  const [showcategorymodal, setshowcategorymodal] = useState(false);
  const openaddcategorymodal = () => {
    setshowcategorymodal(true);
  };
  const closeaddcategorymodal = () => {
    setshowcategorymodal(false);
  };
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);

  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  const [currentPage, setCurrentPage] = useState(1);

  const [employmentTypeFilter, setEmploymentTypeFilter] = useState("");
  const filteredData = data.filter((item) => {
    const fullName =
      `${item.firstname} ${item.lastname} ${item.empcode} ${item.designation} ${item.mobile} ${item.emptype} ${item.department}`.toLowerCase();
    const departmentFilterMatch =
      department === "" || item.department === department;
    const searchMatch =
      !searchQuery || fullName.includes(searchQuery.toLowerCase());
    return (
      departmentFilterMatch &&
      searchMatch &&
      (!employmentTypeFilter ||
        (item.emptype || item.emp_type || "Unspecified") ===
          employmentTypeFilter)
    );
  });
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const paginationOptions = [
    { label: "100", value: 100 },
    { label: "150", value: 150 },
    { label: "250", value: 250 },
    { label: "500", value: 500 },
  ];
  const handleItemsPerPageChange = (selectedOption) => {
    setItemsPerPage(selectedOption.value);
    setCurrentPage(1);
  };
  const selectOptions = paginationOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  const departmentCounts = Object.entries(
    data.reduce((counts, employee) => {
      const label = employee.department?.trim() || "Unassigned";
      counts[label] = (counts[label] || 0) + 1;
      return counts;
    }, {}),
  ).sort((a, b) => b[1] - a[1]);
  const employmentCounts = Object.entries(
    data.reduce((counts, employee) => {
      const label = employee.emptype || employee.emp_type || "Unspecified";
      counts[label] = (counts[label] || 0) + 1;
      return counts;
    }, {}),
  ).sort((a, b) => b[1] - a[1]);
  const share = (count) =>
    data.length ? Math.round((count / data.length) * 100) : 0;
  return (
    <div className="employee-management">
      {showOverlay && overlayImageUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseOverlay}
        >
          <img
            src={overlayImageUrl}
            alt="Profile Overlay"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
            }}
          />
        </div>
      )}
      <AdddepartmentHrmodal
        show={showcategorymodal}
        hide={closeaddcategorymodal}
        getDepartmentList={getDepartmentList}
      />
      <div
        className="employee-page-content"
        style={{
          borderTopLeftRadius: ".4rem",
          borderTopRightRadius: ".4rem",
        }}
      >
        <div className="tab-custom-pills-horizontal m-0 p-0 py-1">
          <header className="employee-page-heading">
            <div className="mt-3">
              {/* <div className="employee-breadcrumb"><FiHome /> HR &amp; People <FiChevronRight /> <strong>Employee Management</strong></div> */}
              <h1 className="m-0">Employee Management</h1>
              {/* <p>
                Manage your team members, view details, and organize them by
                department.
              </p> */}
            </div>
            <button
              className="employee-export"
              onClick={() =>
                ExportToExcel(
                  `employee_ledger${now()}`,
                  excelMapping(data, columns),
                )
              }
            >
              <FiDownload /> Export to Excel
            </button>
          </header>
          <div className="employee-reference-summary">
            {[
              {
                label: "Total Employees",
                count: data.length,
                Icon: FiUsers,
                tone: "blue",
                detail: "Across all departments",
              },
              {
                label: "IT Department",
                count: data.filter((employee) => employee.department === "IT")
                  .length,
                Icon: FiMonitor,
                tone: "green",
              },
              {
                label: "Sales Department",
                count: data.filter(
                  (employee) => employee.department === "Sales",
                ).length,
                Icon: FiTrendingUp,
                tone: "purple",
              },
              {
                label: "Support Department",
                count: data.filter(
                  (employee) => employee.department === "Support",
                ).length,
                Icon: FiHeadphones,
                tone: "amber",
              },
            ].map(({ label, count, Icon, tone, detail }) => (
              <div className={`employee-reference-stat ${tone}`} key={label}>
                <span className={`employee-summary-icon ${tone}`}>
                  <Icon />
                </span>
                <div>
                  <span>{label}</span>
                  <strong>{count}</strong>
                  <small>{detail || `${share(count)}% of total`}</small>
                </div>
              </div>
            ))}
            <section className="employee-reference-distribution">
              <h2>Department Wise Distribution</h2>
              <div className="employee-donut-content">
                <div
                  className="employee-donut"
                  role="img"
                  aria-label={`Department distribution for ${data.length} employees`}
                  style={{
                    background: data.length
                      ? `conic-gradient(${departmentCounts
                          .map(([, count], index) => {
                            const start =
                              (departmentCounts
                                .slice(0, index)
                                .reduce((sum, [, n]) => sum + n, 0) /
                                data.length) *
                              100;
                            return `${["#3294ff", "#a15df4", "#ffce45", "#30bf88", "#ff527c"][index % 5]} ${start}% ${start + (count / data.length) * 100}%`;
                          })
                          .join(", ")})`
                      : "#edf1f7",
                  }}
                >
                  <div>
                    <strong>{data.length}</strong>
                    <span>Total</span>
                  </div>
                </div>
                <div className="employee-donut-legend">
                  {departmentCounts.map(([label, count], index) => (
                    <div key={label}>
                      <i
                        style={{
                          background: [
                            "#3294ff",
                            "#a15df4",
                            "#ffce45",
                            "#30bf88",
                            "#ff527c",
                          ][index % 5],
                        }}
                      />
                      <span>{label}</span>
                      <strong>
                        {count} <small>({share(count)}%)</small>
                      </strong>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>

          <div
            className="card employee-list-card"
            style={{ borderRadius: ".4rem", border: "none" }}
          >
            <div className="row employee-list-toolbar">
              <div className="col-md-5 col-3">
                <h5
                  className="d-flex align-items-center"
                  style={{ color: "#0074D9" }}
                >
                  Employee List
                </h5>
              </div>
              <div className="col d-flex justify-content-end">
                <input
                  style={{
                    background: "#fff",
                    borderRadius: ".4rem",
                    width: "30% ",
                    border: "1px #ced4da solid",
                    paddingLeft: "10px",
                    height: "2rem",
                  }}
                  type="text"
                  placeholder="Search by name, employee code, designation…"
                  aria-label="Search employees"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                />
                <div className="col d-flex justify-content-end">
                  <select
                    style={{
                      // width: "9rem",
                      height: "2rem",
                      borderRadius: ".4rem",
                      border: "1px #ced4da solid",
                    }}
                    value={department}
                    onChange={(e) => {
                      setDepartment(e.target.value);
                    }}
                  >
                    <option value="">All Departments</option>
                    {departmentData.map((dept) => (
                      <option key={dept.id} value={dept.cat1}>
                        {dept.cat1}
                      </option>
                    ))}
                  </select>
                </div>
                <select
                  aria-label="Employment Type"
                  value={employmentTypeFilter}
                  onChange={(e) => {
                    setEmploymentTypeFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">All Employment Types</option>
                  {employmentCounts.map(([label]) => (
                    <option key={label} value={label}>
                      {label}
                    </option>
                  ))}
                </select>
                <button
                  className="employee-reset"
                  onClick={() => {
                    setSearchQuery("");
                    setDepartment("");
                    setEmploymentTypeFilter("");
                    setCurrentPage(1);
                  }}
                >
                  Reset
                </button>
                <Link
                  onClick={openaddcategorymodal}
                  type="button"
                  className="btn btn-sm btn-primary d-flex justify-content-center ms-2"
                  style={{
                    color: "#fff",
                    height: "2rem",
                    border: "none",
                    borderRadius: ".4rem",
                    display: "flex",
                    alignItems: "center",
                    // width: "9rem",
                    fontSize: ".8rem",
                  }}
                >
                  Add Department
                </Link>
                {accessData &&
                  accessData.map(
                    (module) =>
                      module.data &&
                      module.data.map((role) =>
                        role.role_name === "Add Employee" ? (
                          role.access === "Y" ? (
                            <span
                              key={role.pk_role_id}
                              style={{ marginLeft: "10px" }}
                            >
                              <Link
                                to="/admin/EmployeeFormAdmin"
                                type="button"
                                className="btn btn-sm btn-primary d-flex justify-content-center"
                                style={{
                                  color: "#fff",
                                  height: "2rem",
                                  border: "none",
                                  borderRadius: ".4rem",
                                  display: "flex",
                                  alignItems: "center",
                                  width: "7rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Add Employee
                              </Link>
                            </span>
                          ) : (
                            <span
                              key={role.pk_role_id}
                              style={{ marginLeft: "10px" }}
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex justify-content-center"
                                style={{
                                  color: "#fff",
                                  height: "2rem",
                                  border: "none",
                                  borderRadius: ".4rem",
                                  display: "flex",
                                  alignItems: "center",
                                  width: "7rem",
                                  fontSize: ".8rem",
                                  backgroundColor: "gray",
                                  cursor: "not-allowed",
                                }}
                                disabled
                              >
                                Add Employee
                              </button>
                            </span>
                          )
                        ) : null,
                      ),
                  )}
              </div>
            </div>
            <hr className="p-0 mx-md-1 m-0 p-0" />
            <div className="employee-table-scroll">
              <table
                className="employee-table"
                style={{
                  textAlign: "center",
                  overflow: "",
                }}
              >
                <thead>
                  <tr>
                    {[
                      // "#",
                      "Employee",
                      "Employee Code",
                      "Designation",
                      "Department",
                      "Mobile",
                      "Qualification",
                      "Joining Date",
                      "Actions",
                    ].map((label) => (
                      <th key={label}>{label}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className="mx-md-2">
                  {currentItems.length > 0 ? (
                    currentItems.map((item, employeeIndex) => {
                      const fullName =
                        `${item.firstname} ${item.lastname} ${item.empcode} ${item.designation} ${item.mobile} ${item.emptype} ${item.department}`.toLowerCase();
                      if (
                        !searchQuery ||
                        fullName.includes(searchQuery.toLowerCase())
                      ) {
                        return (
                          <tr
                            key={item.id}
                            style={{ borderBottom: "1px solid #ced4da" }}
                          >
                            {/* <td>{indexOfFirstItem + employeeIndex + 1}</td> */}
                            <td>
                              <div className="employee-reference-person">
                                {item.image_url ? (
                                  <img
                                    src={item.image_url}
                                    alt={`${item.firstname} ${item.lastname}`}
                                    onClick={() =>
                                      handleImageClick(item.image_url)
                                    }
                                  />
                                ) : (
                                  <span className="employee-initials">
                                    {item.firstname?.[0]}
                                    {item.lastname?.[0]}
                                  </span>
                                )}
                                <div>
                                  <strong>
                                    {item.firstname} {item.lastname}
                                  </strong>
                                  <small>{item.workemail || item.email}</small>
                                </div>
                              </div>
                            </td>
                            <td>{item.empcode}</td>
                            <td
                              className="text-center align-middle"
                              style={{
                                border: "none",
                                fontSize: ".8rem",
                                fontWeight: "700",
                              }}
                            >
                              {item.designation}
                            </td>
                            <td
                              className="text-center align-middle"
                              style={{
                                border: "none",
                                fontSize: ".8rem",
                                fontWeight: "700",
                              }}
                            >
                              <span className="employee-department-badge">
                                {item.department || "Unassigned"}
                              </span>
                            </td>
                            <td
                              className="text-center align-middle"
                              style={{
                                border: "none",
                                fontSize: ".8rem",
                                fontWeight: "700",
                              }}
                            >
                              {item.mobile}
                            </td>
                            <td
                              className="text-center align-middle"
                              style={{
                                border: "none",
                                fontSize: ".8rem",
                                fontWeight: "700",
                              }}
                            >
                              {item.qualification}
                            </td>
                            <td
                              className="text-center align-middle"
                              style={{
                                border: "none",
                                fontSize: ".8rem",
                                fontWeight: "700",
                              }}
                            >
                              {(() => {
                                if (!item.joiningdate) {
                                  return "Invalid Date";
                                }

                                const rawDate = item.joiningdate.split(" ,")[0];
                                const [day, month, year] = rawDate.split("-");
                                const formattedDate = `20${year}-${month}-${day}`;

                                const date = new Date(formattedDate);
                                return date.getTime()
                                  ? date.toLocaleDateString()
                                  : "Invalid Date";
                              })()}
                            </td>

                            {/* <td
                            className="text-center align-middle"
                            style={{
                              border: "none",
                              fontSize: ".8rem",
                              fontWeight: "700",
                            }}
                          >
                            {item?.pan?.replace(/.(?=.{3})/g, "*")}
                          </td> */}
                            <td
                              className="text-center align-middle"
                              style={{ border: "none", fontSize: "1rem" }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  // marginRight: "5px",
                                }}
                                className="adminemp-tooltip-container"
                              >
                                <img
                                  alt=""
                                  src={documentUploadIcon}
                                  onClick={() =>
                                    openDocumentUploadModal(
                                      item.empid,
                                      item.firstname,
                                      item.lastname,
                                    )
                                  }
                                  className="adminemp-tooltip-icon"
                                />
                                <span className="adminemp-tooltip-text">
                                  Upload Document
                                </span>
                              </div>

                              {accessData &&
                                accessData.map(
                                  (module) =>
                                    module.data &&
                                    module.data.map((role) =>
                                      role.role_name === "Edit Employee" ? (
                                        role.access === "Y" ? (
                                          <span
                                            key={role.pk_role_id}
                                            style={{ marginLeft: "3px" }}
                                          >
                                            <div
                                              style={{
                                                position: "relative",
                                                display: "inline-block",
                                                marginRight: "3px",
                                              }}
                                              className="adminemp-tooltip-container"
                                            >
                                              <img
                                                alt=""
                                                src={editIcon}
                                                onClick={() =>
                                                  openEditModal(
                                                    item,
                                                    item.empid,
                                                  )
                                                }
                                                style={{ height: "2.8rem" }}
                                                className="adminemp-tooltip-icon"
                                              />
                                              <span className="adminemp-tooltip-text">
                                                Edit Employee
                                              </span>
                                            </div>
                                          </span>
                                        ) : (
                                          <Link
                                            style={{
                                              marginRight: "3px",
                                              pointerEvents: "none",
                                              opacity: 0.5,
                                            }}
                                            className="tooltip-container"
                                          >
                                            <img
                                              alt=""
                                              src={require("../../assets/images/pms/Edit_icon.svg")}
                                              onClick={() =>
                                                openEditModal(item, item.empid)
                                              }
                                              style={{ height: "2.8rem" }}
                                            />
                                          </Link>
                                        )
                                      ) : null,
                                    ),
                                )}

                              {accessData &&
                                accessData.map(
                                  (module) =>
                                    module.data &&
                                    module.data.map((role) =>
                                      role.role_name === "Delete Employee" ? (
                                        role.access === "Y" ? (
                                          <span
                                            key={role.pk_role_id}
                                            // style={{ marginLeft: "10px" }}
                                          >
                                            <div
                                              style={{
                                                position: "relative",
                                                display: "inline-block",
                                                // marginRight: "5px",
                                              }}
                                              className="adminemp-tooltip-container"
                                            >
                                              <img
                                                alt=""
                                                src={deleteIcon}
                                                onClick={() =>
                                                  deleteEmployee(item.empid)
                                                }
                                                style={{ height: "2.8rem" }}
                                                className="adminemp-tooltip-icon"
                                              />
                                              <span className="adminemp-tooltip-text">
                                                Delete Employee
                                              </span>
                                            </div>
                                          </span>
                                        ) : (
                                          <Link
                                            style={{
                                              marginRight: "5px",
                                              pointerEvents: "none",
                                              opacity: 0.5,
                                            }}
                                            className="tooltip-container"
                                          >
                                            <img
                                              alt=""
                                              src={require("../../assets/images/pms/Delete_icon.svg")}
                                              onClick={() =>
                                                deleteEmployee(item.empid)
                                              }
                                              style={{ height: "2.8rem" }}
                                            />
                                          </Link>
                                        )
                                      ) : null,
                                    ),
                                )}

                              <span
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                {popoverStates[item.empid] && (
                                  <>
                                    <div
                                      className="disablepop"
                                      style={{
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #ced4da",
                                        borderRadius: ".4rem",
                                        padding: "8px",
                                        boxShadow:
                                          "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        marginLeft: "-4rem",
                                        zIndex: 100,
                                        position: "absolute",
                                        width: "6rem",
                                      }}
                                    >
                                      {accessData &&
                                        accessData.map(
                                          (module) =>
                                            module.data &&
                                            module.data.map((role) =>
                                              role.role_name ===
                                              "Disable Employee" ? (
                                                role.access === "Y" ? (
                                                  <span
                                                    key={role.pk_role_id}
                                                    style={{
                                                      marginLeft: "10px",
                                                      fontSize: ".8rem",
                                                    }}
                                                  >
                                                    <Link
                                                      onClick={() =>
                                                        employeedisable(
                                                          item.empid,
                                                        )
                                                      }
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                      className="tooltip-container"
                                                    >
                                                      Disable
                                                    </Link>
                                                  </span>
                                                ) : (
                                                  <Link
                                                    style={{
                                                      marginRight: "5px",
                                                      pointerEvents: "none",
                                                      opacity: 0.5,
                                                      fontSize: ".8rem",
                                                    }}
                                                    className="tooltip-container"
                                                  >
                                                    Disable
                                                  </Link>
                                                )
                                              ) : null,
                                            ),
                                        )}
                                      <hr className="m-0 p-0" />
                                      <a
                                        href={`https://billpunch.com/OfferLetter/pdfdownload.php?empid=${item.empid}`}
                                        style={{
                                          marginRight: "5px",
                                          fontSize: ".8rem",
                                        }}
                                        className="tooltip-container"
                                        download
                                      >
                                        Offer letter
                                      </a>

                                      {/* <hr /> */}

                                      {/* <h6>
                        <Link
                          onClick={() =>
                            opencredentialmodal(
                              item.empid,
                              item.email
                            )
                          }
                        >
                          Credential
                        </Link>
                      </h6> */}
                                    </div>
                                  </>
                                )}
                              </span>
                              <FaEllipsisV
                                onClick={() => togglePopover(item.empid)}
                              />
                            </td>
                          </tr>
                        );
                      }
                      return null;
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center align-middle"
                        style={{ fontSize: "1rem", fontWeight: "700" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="employee-pagination">
              <label>Items per page:</label>
              <div style={{ width: "6rem" }}>
                <Select
                  options={selectOptions}
                  value={{ value: itemsPerPage, label: `${itemsPerPage}` }}
                  onChange={handleItemsPerPageChange}
                  style={{ width: "4rem" }}
                />
              </div>
            </div>
            <DocumentModalAdmin
              show={docmodal}
              onHide={closeDocumentUploadModal}
              selectedEmployeeId={selectedEmployeeId}
              getEmployeeList={getEmployeeList}
              data={setData}
            />

            <EditEmployeeModalAdmin
              show={isModalOpen}
              onHide={() => setIsModalOpen(false)}
              employeeData={selectedEmployee}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              validateForm={validateForm}
              handleEditSubmit={handleEditSubmit}
              empid={selectedEmployeeId}
              getEmployeeList={getEmployeeList}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListAdmin;
